import React, { useState } from 'react';
import MainRoutePage from '../shipment/route';
import { ShipFormProvider } from '../../context/shipForms';
import ManualShipmentNav from './manualShipmentNav';
import { Link } from 'react-router-dom';

function ManualShipmentContainer() {
  const [currentShipmentStatus, setCurrentShipmentStatus] = useState('route');
  return (
    <ShipFormProvider>
      <div className='container-fluid my-5 px-5'>
        <ManualShipmentNav currentShipmentStatus={currentShipmentStatus} />
        <div className='row'>
          <div className='col-md-3 my-auto'></div>
          <div className='col-md-3 text-center'></div>

          <div className='col-md-6 text-end'>
            <small className='mandatory-label' id='mandatory_field_small'>
              * mandatory fields
            </small>
          </div>
        </div>
        <MainRoutePage setCurrentShipmentStatus={setCurrentShipmentStatus} />
        {currentShipmentStatus !== 'Loading' && (
          <div className='row my-3'>
            <div className='col-sm-12 '>
              <small>
                The Platform is a shipping service provided by BBE Expediting
                Ltd. The Platform shipping service is trans actioned in
                accordance with the Service Description and Other Terms and
                Conditions. Upon acceptance of this quote, you are subject to
                the described Platform shipping service and to the other terms
                and conditions. A copy is available from BBE upon request or may
                be found on our website:{' '}
                <Link target='_blank' to={`${process.env.REACT_APP_TERMS_URL}`}>
                  Terms & Conditions
                </Link>
                .
              </small>
            </div>
          </div>
        )}
      </div>
    </ShipFormProvider>
  );
}

export default ManualShipmentContainer;
